export enum FeatureToggle {
  webhookConfiguration = 'rt_webhook_configuration',
}
